export default  {
    notVerified: 0,
    verified: 1,
    verifying: 2
}